interface FormatMinutesOptions {
  // Note: hours are zero-padded ("08:30 AM") by default; reservations show "8:30 AM" instead.
  padHours?: boolean
}

export const formatMinutes = (
  mins: number,
  { padHours = true }: FormatMinutesOptions = {},
): string => {
  // Note: mins can be 1440 (the "end of day"/midnight sentinel used e.g. by amenity time
  // blocks) - wrap hours to the 0-23 range before deriving the AM/PM period.
  const hours = Math.floor(mins / 60) % 24
  const minutes = mins % 60
  const period = hours >= 12 ? 'PM' : 'AM'
  const hours12 = hours % 12 === 0 ? 12 : hours % 12
  const hoursText = padHours ? String(hours12).padStart(2, '0') : String(hours12)
  return `${hoursText}:${String(minutes).padStart(2, '0')} ${period}`
}
